import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IntegrationUpdate } from '@core/models/integration-update.model';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';
@Injectable()
export class IntegrationUpdateService {
  tableParams = {
    page: 1,
    page_size: 25,
  };

  constructor(private httpClient: HttpClient) {}

  updateFilters(page: number, page_size: number) {
    this.tableParams.page = page;
    this.tableParams.page_size = page_size;
  }

  getIntegrationLog(): any {
    const params = new HttpParams({ fromObject: this.tableParams });
    const route = `${environment.examInfoBackend}/lis/integration_updates`;
    return this.httpClient.get(route, { params, responseType: 'json' });
  }

  getIntegationLogById(id: number): Observable<IntegrationUpdate> {
    const route = `${environment.examInfoBackend}/lis/integration_updates/${id}`;
    return this.httpClient.get<IntegrationUpdate>(route);
  }

  getResourceStatus(code: string) {
    const route = `${environment.examInfoBackend}/lis/resource_status/${code}`;
    return this.httpClient.get<any>(route);
  }
}
